import { useContext } from 'react';
import { m as merge } from '../../unsorted/index.js';
import { useTheme } from '../../hooks/useTheme.js';
import { M as ModalOverlay } from '../../overlays/ModalOverlay/ModalOverlay.js';
import { B as BiomePortalIdContext } from '../BiomePortalIdProvider/BiomePortalIdProvider.js';
import { p as positionedOverlayContainerCss } from '../shared/shared.js';
import { B as BiomeOverlaysProvider } from '../overlaysContext/overlaysContext.js';
import { jsxs, jsx } from '@emotion/react/jsx-runtime';
import '@emotion/react';
import { C as ClientOnlyPortal } from '../../overlays/ClientOnlyPortal/ClientOnlyPortal.js';
import { D as DrawerOverlay } from '../../overlays/DrawerOverlay/DrawerOverlay.js';
import { P as PopoverOverlay } from '../../overlays/PopoverOverlay/PopoverOverlay.js';
import { T as ToastOverlay } from '../../overlays/ToastOverlay/ToastOverlay.js';

var MODAL_SELECTOR = "modal-container";
var DRAWER_SELECTOR = "drawer-container";
var POPOVER_SELECTOR = "popover-container";
var TOAST_SELECTOR = "toast-container";
function MountedOverlaysAndProvider(_ref) {
  var children = _ref.children,
    modalContainerId = _ref.modalContainerId,
    drawerContainerId = _ref.drawerContainerId,
    popoverContainerId = _ref.popoverContainerId,
    toastContainerId = _ref.toastContainerId;
  var portalId = useContext(BiomePortalIdContext);
  var _useTheme = useTheme(),
    zLevel = _useTheme.base.zLevel;
  return jsxs(BiomeOverlaysProvider, {
    children: [children, jsx(ClientOnlyPortal, {
      selector: modalContainerId ? "#".concat(modalContainerId) : "#".concat(MODAL_SELECTOR).concat(portalId),
      children: jsx(ModalOverlay, {
        hasExternalContainer: Boolean(modalContainerId)
      })
    }), !modalContainerId && jsx("div", {
      id: "".concat(MODAL_SELECTOR).concat(portalId)
    }), jsx(ClientOnlyPortal, {
      selector: drawerContainerId ? "#".concat(drawerContainerId) : "#".concat(DRAWER_SELECTOR).concat(portalId),
      children: jsx(DrawerOverlay, {
        hasExternalContainer: Boolean(drawerContainerId)
      })
    }), !drawerContainerId && jsx("div", {
      id: "".concat(DRAWER_SELECTOR).concat(portalId)
    }), jsx(ClientOnlyPortal, {
      selector: popoverContainerId ? "".concat(popoverContainerId) : "#".concat(POPOVER_SELECTOR).concat(portalId),
      children: jsx(PopoverOverlay, {})
    }), !popoverContainerId && jsx("div", {
      id: "".concat(POPOVER_SELECTOR).concat(portalId),
      css: merge(positionedOverlayContainerCss, {
        zIndex: zLevel.popover
      })
    }), jsx(ClientOnlyPortal, {
      selector: toastContainerId ? "#".concat(toastContainerId) : "#".concat(TOAST_SELECTOR).concat(portalId),
      children: jsx(ToastOverlay, {})
    }), !toastContainerId && jsx("div", {
      id: "".concat(TOAST_SELECTOR).concat(portalId)
    })]
  });
}

export { MountedOverlaysAndProvider as M };
//# sourceMappingURL=MountedOverlaysAndProvider.js.map
